/* eslint-disable */

export enum RewardSlotState {
  LOCKED = "LOCKED",
  EMPTY = "EMPTY",
  OCCUPIED = "OCCUPIED",
}

export interface BlockedOnRequirements {
  user_confirmation?: BlockedOnRequirementsUserConfirmation;
  removal_user_confirmation?: BlockedOnRequirementsRemovalUserConfirmation;
  /** @deprecated */
  issued_card_required?: BlockedOnRequirementsIssuedCardRequired;
}

export interface BlockedOnRequirementsUserConfirmation {
  reason?: BlockedOnRequirementsUserConfirmationReason;
  /** Lock down window in milliseconds. */
  lock_down_window_ms?: number;
}

export enum BlockedOnRequirementsUserConfirmationReason {
  REPLACE_REWARD = "REPLACE_REWARD",
  REPLACE_DISABLED_REWARD = "REPLACE_DISABLED_REWARD",
  REPLACE_DISABLED_REWARD_USE_SWAP = "REPLACE_DISABLED_REWARD_USE_SWAP",
  REPLACE_UPDATED_REWARD = "REPLACE_UPDATED_REWARD",
  REPLACE_UPDATED_REWARD_USE_SWAP = "REPLACE_UPDATED_REWARD_USE_SWAP",
}

export interface BlockedOnRequirementsRemovalUserConfirmation {
  reason?: BlockedOnRequirementsRemovalUserConfirmationReason;
  /** Lock down window in milliseconds. */
  lock_down_window_ms?: number;
}

export enum BlockedOnRequirementsRemovalUserConfirmationReason {
  REMOVE_REWARD_USE_SWAP = "REMOVE_REWARD_USE_SWAP",
  REMOVE_DISABLED_REWARD = "REMOVE_DISABLED_REWARD",
  REMOVE_DISABLED_REWARD_USE_SWAP = "REMOVE_DISABLED_REWARD_USE_SWAP",
  REMOVE_UPDATED_REWARD = "REMOVE_UPDATED_REWARD",
  REMOVE_UPDATED_REWARD_USE_SWAP = "REMOVE_UPDATED_REWARD_USE_SWAP",
}

export interface BlockedOnRequirementsIssuedCardRequired {
}

export interface CardRequestInfo {
  style_picker_eligible?: boolean;
  metal_card_eligible?: boolean;
  three_dimensional_eligible?: boolean;
}
